import React from "react";
import { chakra, Box, Image, useMultiStyleConfig } from "@chakra-ui/react";
export function SelectOptionAccessory({ accessory, }) {
    const styles = useMultiStyleConfig("SelectOptionAccessory");
    return (React.createElement(chakra.div, { __css: styles["container"] },
        accessory.type === "image" && (React.createElement(Image, { src: accessory.url, __css: styles["accessory"], "aria-hidden": "true" })),
        accessory.type === "icon" && (React.createElement(Box, { as: accessory.icon, __css: styles["accessory"], "aria-hidden": "true" }))));
}
